import { useReportIsVerified } from "./useReportIsVerified";
import { PropsWithChildren } from "react";

type WhenVerifiedProps = PropsWithChildren<{
  fallback?: React.ReactNode;
}>;

export function WhenVerified({ fallback, children }: WhenVerifiedProps) {
  const isVerified = useReportIsVerified();
  if (!isVerified) {
    return fallback;
  }
  return <>{children}</>;
}
